import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { storeWriteSettingsAdapts, StoreWriteSettingsAdapter } from './store-write-settings.adapter';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { SharePointOnlineFileWriteSettings } from 'app/model/pipeline/copysink/store-write-settings/sharepoint-online-file-store-write-settings';

@AdapterRegistry.adapter({
    model:  Metamodel.modelFor(SharePointOnlineFileWriteSettings),
    asynchronous: true,
    adapts: {
        ...storeWriteSettingsAdapts
    }
})

export class SharePointOnlineFileWriteSettingsAdapter extends StoreWriteSettingsAdapter<SharePointOnlineFileWriteSettings, Model.StoreWriteSettings> {
    protected override async _toResource(model: SharePointOnlineFileWriteSettings): Promise<Model.StoreWriteSettings> {
        const result: Model.StoreWriteSettings = await super._toResource(model);
        StoreWriteSettingsAdapter.toStoreWriteSettingsResource(model, result);
        return result;
    }

    protected override async _toModel(resource: Model.StoreWriteSettings, copySink: CopySink): Promise<SharePointOnlineFileWriteSettings> {
        const result = await super._toModel(resource, copySink);
        StoreWriteSettingsAdapter.toStoreWriteSettingsModel(resource, result);
        return result;
    }
}
